/**
 * CSS definitions that can be applied to a
 *   component. All standard CSS rules can apply,
 *   including selectors, child properties, etc.
 *
 * Variants can be used to define styling that
 *   will be conditionally applied based on
 *   the `variant` field of the component.
 */

/**
 * Returns the Variant literals of a particular OwnUp style.
 */

/**
 * A single element or an array of the Variant Literals defined by the
 *   input style.
 */

/**
 * Enforces the proper typing of an OwnUp style and its variants
 *
 * @param input see {@link OwnUpStyle}
 */
export var createOwnUpStyle = function createOwnUpStyle(input) {
  return input;
};